import React from "react";
import { Link } from "react-router-dom";
import { useCategoriesFlat } from "@/hooks/useCategories";
import { ChevronRight, Pencil } from "lucide-react";

/**
 * Displays "Category › Subcategory" for a pre-chosen post form, with a
 * "Change category" link back to /sell.
 *
 * Names come from `useCategories()` (already cached) — no extra fetch. If
 * the ids can't be resolved (stale URL), we render just the "Change
 * category" link so the user can restart cleanly.
 */
export default function CategoryBreadcrumbChip({
  categoryId,
  subcategoryId,
  fallbackLabel,
  testId = "change-category",
}) {
  const { flat } = useCategoriesFlat();
  const cat = flat?.find((c) => c.id === categoryId);
  const sub = flat?.find((c) => c.id === subcategoryId);
  const hasAny = cat || sub || fallbackLabel;
  if (!hasAny) return null;

  return (
    <div
      data-testid={`${testId}-wrap`}
      className="mt-2 flex flex-wrap items-center gap-2 text-sm"
    >
      <span className="inline-flex items-center gap-1 text-slate-600">
        {cat?.name || fallbackLabel || "Category"}
        {sub && (
          <>
            <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
            <span className="font-semibold text-slate-800">{sub.name}</span>
          </>
        )}
      </span>
      <Link
        to="/sell"
        data-testid={testId}
        className="inline-flex items-center gap-1 text-xs font-semibold text-[color:var(--brand-blue)] hover:underline"
      >
        <Pencil className="w-3 h-3" /> Change category
      </Link>
    </div>
  );
}
